<template>
  <!-- 发送短信验证码组件 -->
  <div class="send-sms-container">
    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="100px"
      class="send-sms-form"
    >
      <!-- form-start -->
      <el-form-item label="手机号:" prop="phone">
        <el-input
          v-model="formData.phone"
          placeholder="请输入11位手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码:" prop="smsCode">
        <div class="send-sms-code-bg">
          <div class="send-sms-code-inp">
            <el-input
              v-model="formData.smsCode"
              autocomplete="off"
              placeholder="请输入验证码"
            ></el-input>
          </div>
          <div class="send-sms-code-send">
            <button
              type="button"
              v-bind:disabled="btn.busy"
              v-on:click="SendSmsCode"
              class="send-sms-code-btn"
              :class="{ 'send-code-busy': btn.busy }"
            >
              {{ sendSmsText }}
            </button>
          </div>
        </div>
      </el-form-item>
      <!-- btn -->
      <el-form-item>
        <div class="send-sms-sub">
          <el-button
            :loading="loading"
            type="primary"
            @click.native="SendSmsSubmit('formData')"
            >下一步</el-button
          >
        </div>
      </el-form-item>
      <!-- form-end -->
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'SmsSend',
  props: {
    post: {
      type: Object
    }
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入11位手机号码'))
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    var validateSmsCode = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('请输入验证码'))
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        phone: '',
        smsCode: ''
      },
      loading: false,
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        smsCode: [{ validator: validateSmsCode, trigger: 'blur' }]
      },
      postContent: {
        spaceMax: 60
      },
      btn: {
        text: '发送验证码',
        spaceMax: 60,
        space: 0,
        busy: false,
        timer: Object
      }
    }
  },
  computed: {
    sendSmsText() {
      if (this.btn.busy) {
        return `${this.btn.space}s后重新发送`
      } else {
        return `${this.btn.text}`
      }
    }
  },
  created() {
    Object.assign(this.postContent, this.post)
    this.btn.spaceMax = this.postContent.spaceMax
  },
  methods: {
    SendSmsCode() {
      this.$refs.formData.validateField('phone', isError => {
        if (!isError) {
          this.btn.space = this.btn.spaceMax
          this.btn.busy = true
          this.btn.timer = setInterval(() => {
            this.btn.space--
            if (this.btn.space === 0) {
              this.btn.busy = false
              clearInterval(this.btn.timer)
            }
          }, 1000)
          this.$emit('SendSmsCode', this.formData)
        } else {
          console.log('phone验证失败')
        }
      })
    },
    SendSmsSubmit(formName) {
      this.loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('SendSmsSubmit', this.formData)
        } else {
          console.log('error submit!!')
        }
        this.loading = false
      })
    }
  }
}
</script>
<style>
.send-sms-container .send-sms-form .el-form-item {
  margin-bottom: 30px;
}
.send-sms-container .send-sms-sub .el-button {
  width: 140px;
}
.send-sms-container .send-sms-form .el-input__inner {
  background-color: #ffffff;
}
</style>
<style lang="scss" scoped>
.send-sms-container {
  display: flex;
  width: 460px;
  .send-sms-form {
    width: 100%;
    .send-sms-code-bg {
      display: flex;
      width: 100%;
      .send-sms-code-inp {
        width: 210px;
      }
      .send-sms-code-send {
        margin-left: 16px;
        display: flex;
        align-items: center;
        .send-sms-code-btn {
          text-align: center;
          cursor: pointer;
          width: 140px;
          height: 40px;
          border-radius: 5px;
          border: solid 1px #046bcc;
          background: none;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #046bcc;
          outline: none;
        }
        .send-code-busy {
          border-color: #ebebeb;
          color: #928282;
          cursor: default;
        }
      }
    }
    .send-sms-sub {
      margin-top: 20px;
      width: 180px;
    }
  }
}
</style>
